import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import qs from 'qs';

const superagent = superagentPromise(_superagent, global.Promise);

//local
// const API_ROOT = 'http://localhost:8080/v1/api';

//live
export const API_ROOT = '/v1/api';

// export const API_ROOT = '/v1/api'


const encode = encodeURIComponent;
const responseBody = res => res.body;


const withAuth = (req) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? req.set('authorization', `Bearer ${token}`) : req;
};

const requests = {
  del: url =>
    withAuth(superagent.del(`${API_ROOT}${url}`)).then(responseBody),
  get: url =>
    withAuth(superagent.get(`${API_ROOT}${url}`)).then(responseBody),
  put: (url, body) =>
    withAuth(superagent.put(`${API_ROOT}${url}`, body)).then(responseBody),
  post: (url, body) =>
    withAuth(superagent.post(`${API_ROOT}${url}`, body)).then(responseBody)
};


const Common = {
  customer: () => requests.get('/customer'),
  customerByid: (id) => requests.get('/customerByid/' + id),
  vendors: () => requests.get('/vendors'),
  vendor_create: (object) => requests.post('/vendor/create', qs.stringify(object)),
  vendor_update: (id, object) => requests.put('/vendor/update/' + id, qs.stringify(object)),
  vendor_delete: (id) => requests.del('/vendor/delete/' + id),
  services: () => requests.get('/services'),
  servicesByid: (id) => requests.get('/servicesByid/' + id),
  tax: () => requests.get('/tax'),
  company: () => requests.get('/company'),
  invoice: (id) => requests.get('/getInvoiceByid/' + id),
  allinvoice: () => requests.get('/getInvoice'),
  service_create: (object) => requests.post('/service/create', qs.stringify(object)),
  service_update: (id, object) => requests.put('/service/update/' + id, qs.stringify(object)),
  invoice_update: (id) => requests.put('/invoice/update/' + id),
  status_update: (id) => requests.post('/commonStatus/update/' + id),
  delete_update: (id) => requests.post('/commonDelete/update/' + id),
  edit_service: (id, object) => requests.put('/editservice/update/' + id, qs.stringify({ "service_name": object })),
  customercreate: (object) => requests.post('/customer/create', qs.stringify(object)),
  customer_update: (id, object) => requests.put('/customer/update/' + id, qs.stringify(object)),
  sales_create: (object) => requests.post('/sales/create', qs.stringify(object)),
  sales_update: (id, object) => requests.put('/sales/update/' + id, qs.stringify(object)),

  login: (object) => requests.post('/authLogin', qs.stringify(object)),
  profile_create: (object) => requests.post('/profileCreate', qs.stringify(object)),
  profile_update: (id, object) => requests.post('/profileUpdate/' + id, qs.stringify(object)),
  password_update: (id, object) => requests.put('/updatePass/' + id, qs.stringify(object)),
};

const Invoice = {
  create: (customer, invoiceDate, bom, terms, sales,structure) => requests.post('/invoice', qs.stringify({
    "customer": customer,
    "rawText": bom,
    "terms": terms,
     "sales": sales,
    "structure": structure,
// "tax": tax,
    // "po": po,
    // "podate": podate,
    // "payment":payment,
    "createdAt": invoiceDate
  })),
}
const poCreate = {
  create: (customer, service, serviceName, serviceCode,
    polistData, tax, ponuber, podate
  ) => requests.post('/pocreate', qs.stringify({
    "customer": customer,
    "service": service,
    "serviceName": serviceName,
    "serviceCode": serviceCode,
    "polistData": polistData,
    "tax": tax,
    "ponuber": ponuber,
    "podate": podate,
  })),
}

const PurchaseOrders = {
  create: (payload) => requests.post('/purchase-orders', payload),
  list: () => requests.get('/purchase-orders'),
  detail: (id) => requests.get('/purchase-orders/' + id),
  updateStatus: (id, status) => requests.put('/purchase-orders/' + id + '/status', { status })
}

const Ledger = {
  list: (params) => {
    console.log('Ledger.list called with params:', params);
    return withAuth(_superagent.get(`${API_ROOT}/stock-ledger`).query(params))
      .then(responseBody)
      .then(response => {
        console.log('Ledger.list response:', response);
        return response;
      })
      .catch(error => {
        console.error('Ledger.list error:', error);
        throw error;
      });
  }
}
const ItemLedger = {
  timeline: (itemId) => withAuth(_superagent.get(`${API_ROOT}/stock-ledger/item-timeline/${itemId}`)).then(responseBody)
};

const EmailLogs = {
  getFailed: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return withAuth(_superagent.get(`${API_ROOT}/email-logs/failed${query ? `?${query}` : ''}`)).then(responseBody);
  },
  deactivate: (payload) => withAuth(_superagent.patch(`${API_ROOT}/email-logs/deactivate`).send(payload)).then(responseBody),
  deleteByIds: (ids) => withAuth(_superagent.del(`${API_ROOT}/email-logs`).send({ ids })).then(responseBody),
};

const ProposalAndRateCard = {
  logProposalDownload: (payload) =>
    withAuth(_superagent.post(`${API_ROOT}/proposal-downloads`).send(payload)).then(responseBody),
  getProposalDownloads: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return withAuth(_superagent.get(`${API_ROOT}/proposal-downloads${query ? `?${query}` : ''}`)).then(responseBody);
  },
  deleteProposalDownload: (id) => requests.del(`/proposal-downloads/${id}`),
  saveRateCardEntry: (payload) =>
    withAuth(_superagent.post(`${API_ROOT}/rate-card-entries`).send(payload)).then(responseBody),
  getRateCardEntries: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return withAuth(_superagent.get(`${API_ROOT}/rate-card-entries${query ? `?${query}` : ''}`)).then(responseBody);
  },
  deleteRateCardEntry: (id) => requests.del(`/rate-card-entries/${id}`),
  logRateCardDownload: (payload) => withAuth(_superagent.post(`${API_ROOT}/rate-card-downloads`).send(payload)).then(responseBody),
  getRateCardDownloads: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return withAuth(_superagent.get(`${API_ROOT}/rate-card-downloads${query ? `?${query}` : ''}`)).then(responseBody);
  },
  deleteRateCardDownload: (id) => requests.del(`/rate-card-downloads/${id}`),
};

export default {
  Common,
  Invoice,
  poCreate,
  PurchaseOrders,
  Ledger,
  ItemLedger,
  EmailLogs,
  ProposalAndRateCard,
  API_ROOT
};
